/**
 * 验证字符串是否不为空
 * @param {String} str 字符串
 */
export function isNotEmpty(str) {
    return !!str;
}

/**
 * 验证字符串是否为空
 * @param {String} str 字符串
 */
export function isEmpty(str) {
    return !str;
}

/**
 * 验证手机号格式
 * @param {String} phone 待验证手机号
 */
export function isPhone(phone) {
    return /^1\d{10}$/.test(phone);
}

/**
 * 验证密码格式
 * @param {String} password 待验证密码
 */
export function validatePassword(password) {
    return /^(?![^a-zA-Z]+$)(?!\D+$)\w{8,32}$/.test(password);
}
